// extracted by mini-css-extract-plugin
export default {"grow":"vVt2twVsX8fnPl9auT8v","ungrow":"N8P3MmJqQKHGf2x_9OYw"};